<template>
 <v-container class="pa-0">
    <v-card class="pa-0" style="height: calc(100vh - 112px)" >
      <v-card-text class="text-center subtitle-1">
        <slot name="splash-content">
          {{content}}
        </slot>
      </v-card-text>
    </v-card>
</v-container>
</template>
<script>
// the style is the window height minus the app and navbar
export default {
  props: {
    content: String
  }
}
</script>

